/**
 * useSidebarProfile — fetches the current user's profile for the
 * sidebar footer's name + initials + role line.
 *
 * Falls back to placeholder strings on error so the sidebar footer
 * doesn't render "undefined User".
 */

import { useEffect, useState } from 'react';
import { getProfile as getUserProfile } from '../../../modules/user/service';

export type SidebarProfile = { name: string; initials: string; role: string };

export function useSidebarProfile() {
    const [profile, setProfile] = useState<SidebarProfile>({
        name: '', initials: '', role: '',
    });

    useEffect(() => {
        (async () => {
            try {
                const data = await getUserProfile();
                const firstName = typeof data.first_name === 'string' ? data.first_name : '';
                const lastName = typeof data.last_name === 'string' ? data.last_name : '';
                const email = typeof data.email === 'string' ? data.email : '';
                const name = [firstName, lastName].filter(Boolean).join(' ') || email || 'User';
                const initials = firstName && lastName
                    ? `${firstName[0]}${lastName[0]}`.toUpperCase()
                    : name.slice(0, 2).toUpperCase();
                const p = data.profile as { background?: string } | undefined;
                setProfile({ name, initials, role: p?.background ?? '' });
            } catch {
                setProfile({ name: 'User', initials: 'U', role: '' });
            }
        })();
    }, []);

    return profile;
}
